import type { ReactNode } from 'react'

import { useDiscoveryModuleAccess } from '@/lib/app/discovery-module-access.hook'
import { ModuleAccessRoute } from '@/lib/app/module-access-route'

export const DiscoveryModuleRoute = ({ children }: { children: ReactNode }) => {
  const { hasAccess, isLoading } = useDiscoveryModuleAccess()
  return (
    <ModuleAccessRoute hasAccess={hasAccess} isLoading={isLoading}>
      {children}
    </ModuleAccessRoute>
  )
}
